module.exports = __webpack_public_path__ + "img/未标题-10.3fca838f.jpg";